import React from "react";
import { number, string, bool, array, func, element } from "prop-types";
import {
    NavigationPageButton,
    NavigationSelect,
    NavigationViewToggle,
    NavigationFiltersToggle
} from "./index";

const Navigation = ({
    currentPage,
    maxPage,
    pageSize,
    pageSizeOptions,
    sortBy,
    sortByOptions,
    view,
    showView,
    showFilters,
    showActions,
    changeView,
    actionComponent,
    currentPageUrlPrefix,
    pageSizeUrlPrefix,
    goTo,
    changePageSize,
    changeSortBy,
    filtersOnClick
}) => {
    const handlePageChange = (pageTarget, href) => {
        if(Navigation.pushHistoryOnChange){
            history.pushState({page: pageTarget},`page ${pageTarget}`, href);
        }

        goTo(pageTarget);
    };

    const handlePageSizeChange = (newPageSize) => {
        changePageSize(newPageSize);
    };

    const handleSortByChange = (newSortBy) => {
        changeSortBy(newSortBy);
    };

    let min = (currentPage == 1 || maxPage == 1 || currentPage - 2 < 1) ?
        1 : (currentPage != maxPage && currentPage - 2 >= 1) ?
            currentPage - 1 : currentPage - 2;

    let max = (currentPage >= 1 &&
        (currentPage + 2) < 4 && (currentPage + 2) < maxPage) ?
        4 : (currentPage + 2 < maxPage) ?
            currentPage + 2 : maxPage + 1;

    let pageNumbers = [];

    for (let i = min; i < max; i++) {
        pageNumbers.push(<NavigationPageButton
            key={i}
            active={i == currentPage ? true : false}
            currentPage={i}
            pageSize={pageSize}
            currentPageUrlPrefix={currentPageUrlPrefix}
            pageSizeUrlPrefix={pageSizeUrlPrefix}
            goTo={handlePageChange}>
            {i}
        </NavigationPageButton>);
    }

    return (
        <div className="pagination">
            {
                showView && (
                    <NavigationViewToggle
                        changeView={changeView}
                        view={view}
                    />
                )
            }
            {
                showActions && (
                    actionComponent
                )
            }

            <section id="pages">
                {
                    currentPage > 2 && (
                        <NavigationPageButton
                            key={"first"}
                            currentPage={1}
                            pageSize={pageSize}
                            currentPageUrlPrefix={currentPageUrlPrefix}
                            pageSizeUrlPrefix={pageSizeUrlPrefix}
                            goTo={handlePageChange}>
                            &lt;&lt;
                        </NavigationPageButton>
                    )
                }
                {
                    currentPage > 1 && (
                        <NavigationPageButton
                            key={"prev"}
                            previous
                            currentPage={currentPage}
                            pageSize={pageSize}
                            currentPageUrlPrefix={currentPageUrlPrefix}
                            pageSizeUrlPrefix={pageSizeUrlPrefix}
                            goTo={handlePageChange}>
                            &lt;
                        </NavigationPageButton>
                    )
                }
                {pageNumbers}
                {
                    (currentPage < maxPage && currentPage != maxPage) && (
                        <NavigationPageButton
                            key="next"
                            next
                            currentPage={currentPage}
                            pageSize={pageSize}
                            currentPageUrlPrefix={currentPageUrlPrefix}
                            pageSizeUrlPrefix={pageSizeUrlPrefix}
                            goTo={handlePageChange}>
                            &gt;
                        </NavigationPageButton>
                    )
                }
                {
                    currentPage < (maxPage -1) && (
                        <NavigationPageButton
                            key={"last"}
                            currentPage={maxPage}
                            pageSize={pageSize}
                            currentPageUrlPrefix={currentPageUrlPrefix}
                            pageSizeUrlPrefix={pageSizeUrlPrefix}
                            goTo={handlePageChange}>
                            &gt;&gt;
                        </NavigationPageButton>
                    )
                }
            </section>
            <div className="show-per-page">
                <span>Show</span>
                <NavigationSelect
                    key="show-per-page"
                    selectedOption={pageSize}
                    options={pageSizeOptions}
                    changeSelectedOption={handlePageSizeChange}
                />
                <span>Per Page</span>
            </div>
            {sortByOptions.length > 0 && (
                <div className="sort-by">
                    <span>Sort By</span>
                    <NavigationSelect
                        key="sort-by"
                        selectedOption={sortBy}
                        options={sortByOptions}
                        changeSelectedOption={handleSortByChange}
                    />
                </div>
            )}
            {showFilters && (
                <NavigationFiltersToggle
                    onClick={filtersOnClick}
                />
            )}
        </div>
    );
};

Navigation.defaultProps = {
    currentPage: 1,
    pageSize: 16,
    pageSizeOptions: ["24", "48", "64", "96"],
    sortByOptions: [],
    maxPage: 1,
    view: "grid",
    showView: true,
    showActions: false,
    pushHistoryOnChange: true,
    currentPageUrlPrefix: "?currentPage=",
    pageSizeUrlPrefix: "&pageSize="
};

Navigation.propTypes = {
    currentPage: number,
    maxPage: number,
    pageSize: number,
    pageSizeOptions: array,
    sortBy: string,
    sortByOptions: array,
    goTo: func,
    view: string,
    showView: bool,
    showFilters: bool,
    showActions: bool,
    filtersOnClick: func,
    changeSortBy: func,
    changePageSize: func,
    changeView: func,
    actionComponent: element,
    pushHistoryOnChange: bool,
    currentPageUrlPrefix: string,
    pageSizeUrlPrefix: string
};

export default Navigation;